import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-391c296c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "allocation-percentile mt-4" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "option-summary ml-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option-label" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total percentage")
], -1))
const _hoisted_6 = { class: "option-value" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign" }, "%", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" }),
  /*#__PURE__*/_createTextVNode(" Total percentage needs to be at 100% ")
], -1))

export function render(_ctx, _cache) {
  const _component_Percentile = _resolveComponent("Percentile")
  const _component_TextAndPercentile = _resolveComponent("TextAndPercentile")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.question.wording), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.atcsSubQuestions, (q, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (q.atcsQuestionTypeId == _ctx.QuestionType.Percentile)
            ? (_openBlock(), _createBlock(_component_Percentile, {
                key: 0,
                question: _ctx.question.atcsSubQuestions[i],
                "onUpdate:question": $event => ((_ctx.question.atcsSubQuestions[i]) = $event),
                onChanged: $event => (_ctx.onValueChanged($event, i)),
                onValidForm: $event => (_ctx.validationForm(i, $event))
              }, null, 8, ["question", "onUpdate:question", "onChanged", "onValidForm"]))
            : _createCommentVNode("", true),
          (q.atcsQuestionTypeId == _ctx.QuestionType.TextAndPercentile)
            ? (_openBlock(), _createBlock(_component_TextAndPercentile, {
                key: 1,
                question: _ctx.question.atcsSubQuestions[i],
                "onUpdate:question": $event => ((_ctx.question.atcsSubQuestions[i]) = $event),
                onChanged: $event => (_ctx.onValueChanged($event, i)),
                onValidForm: $event => (_ctx.validationForm(i, $event))
              }, null, 8, ["question", "onUpdate:question", "onChanged", "onValidForm"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["input-box", [_ctx.totalPercentage > 100 ? 'error': (_ctx.totalPercentage == 100 ? 'success' : '')]])
        }, [
          _createElementVNode("input", {
            type: "number",
            disabled: true,
            value: _ctx.totalPercentage
          }, null, 8, _hoisted_7),
          _hoisted_8,
          _hoisted_9
        ], 2)
      ])
    ])
  ]))
}